const API_URL      = "https://api.wearlie.com/api/v1/generate/image";
const API_EDIT_URL = "https://api.wearlie.com/api/v1/generate/image/edit";

let selectedCategory  = null;
let generatedImageUrl = null;
let isGenerating      = false;
let isEditing         = false;
let editCount         = 0;
let pendingPrompt     = null;
let lastRequestData   = null;
let wecTimer          = null;
let referenceImage    = null;

const productTypes = {
  shirt:  [
    { value:"crew-neck-tshirt",   displayName:"Crew Neck T-Shirt" },
    { value:"oversized-tshirt",   displayName:"Oversized T-Shirt" },
    { value:"long-sleeve-tshirt", displayName:"Long Sleeve T-Shirt" },
    { value:"v-neck-tshirt",      displayName:"V-Neck T-Shirt" },
    { value:"polo-shirt",         displayName:"Polo Shirt" },
    { value:"raglan-tshirt",      displayName:"Raglan T-Shirt" },
    { value:"sleeveless-tshirt",  displayName:"Sleeveless T-Shirt" }
  ],
  hoodie: [
    { value:"pullover-hoodie",    displayName:"Pullover Hoodie" },
    { value:"zip-up-hoodie",      displayName:"Zip-Up Hoodie" },
    { value:"heavyweight-hoodie", displayName:"Heavyweight Hoodie" }
  ],
  sweatshirt: [
    { value:"crewneck-sweatshirt",  displayName:"Crewneck Sweatshirt" },
    { value:"thermal-sweatshirt",   displayName:"Thermal Sweatshirt" },
    { value:"oversized-sweatshirt", displayName:"Oversized Sweatshirt" }
  ],
  cap: [
    { value:"snapback-cap", displayName:"Snapback Cap" },
    { value:"dad-cap",      displayName:"Dad Cap" },
    { value:"trucker-cap",  displayName:"Trucker Cap" }
  ]
};

/* The four per-garment "Design Your Own" products. */
const variantMap    = { shirt:49148667592948, hoodie:49148668084468, sweatshirt:49148668412148, cap:49148668248308 };
const variantPrices = { shirt:35.85, hoodie:47.85, sweatshirt:37.85, cap:28.85 };

document.addEventListener('DOMContentLoaded', function() {
  initializeEventListeners();
  disableImageDownload();
  initializeCategoryButtons();
  initializeOptionsModal();
  initializeHowItWorks();
  initializeDesignResultModal();
  initializeEditFeature();
  initializeAttachment();
});

function initializeEventListeners() {
  var g = document.getElementById('generateBtn');
  if (g) g.addEventListener('click', handleGenerateClick);
  var c = document.getElementById('modalAddToCartBtn');
  if (c) c.addEventListener('click', handleAddToCart);
}

function initializeAttachment() {
  var file       = document.getElementById('wlRefImage');
  var cam        = document.getElementById('wlRefCamera');
  var row        = document.getElementById('wlRefRow');
  var thumb      = document.getElementById('wlRefThumb');
  var nameEl     = document.getElementById('wlRefName');
  var clearBtn   = document.getElementById('wlRefClear');
  var attachBtn  = document.getElementById('wlAttachBtn');
  var attachMenu = document.getElementById('wlAttachMenu');
  if (!file || !attachBtn || !attachMenu) return;

  var camModal  = document.getElementById('wlCam');
  var camVideo  = document.getElementById('wlCamVideo');
  var camCanvas = document.getElementById('wlCamCanvas');
  var stream = null, facing = 'environment';

  function applyImage(dataUrl, label) {
    referenceImage = dataUrl;
    if (thumb)  thumb.src = dataUrl;
    if (nameEl) nameEl.textContent = label || 'Photo';
    if (row)    row.hidden = false;
  }

  function openMenu(open) {
    attachMenu.hidden = !open;
    attachBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  attachBtn.addEventListener('click', function(e) {
    e.preventDefault(); e.stopPropagation();
    openMenu(attachMenu.hidden);
  });

  attachMenu.addEventListener('click', function(e) {
    var item = e.target.closest('.wl-attachitem');
    if (!item) return;
    openMenu(false);
    if (item.getAttribute('data-attach') === 'camera') {
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      if (coarse) nativeCamera(); else openCamera();
    } else {
      file.click();
    }
  });

  document.addEventListener('click', function(e) {
    if (!attachMenu.hidden && !e.target.closest('.wl-attachwrap')) openMenu(false);
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') openMenu(false);
  });

  function takeFile(input) {
    if (!input) return;
    input.addEventListener('change', function() {
      var f = input.files && input.files[0];
      if (!f) return;
      if (f.size > 6 * 1024 * 1024) {
        showMessage('That image is over 6 MB — please pick a smaller one','error');
        input.value = ''; return;
      }
      var reader = new FileReader();
      reader.onload = function() { applyImage(reader.result, f.name); };
      reader.readAsDataURL(f);
    });
  }
  takeFile(file); takeFile(cam);

  if (clearBtn) {
    clearBtn.addEventListener('click', function() {
      referenceImage = null;
      if (file)   file.value = '';
      if (cam)    cam.value  = '';
      if (thumb)  thumb.removeAttribute('src');
      if (nameEl) nameEl.textContent = '';
      if (row)    row.hidden = true;
    });
  }

  function nativeCamera() { if (cam) cam.click(); else file.click(); }

  function stopStream() {
    if (!stream) return;
    stream.getTracks().forEach(function(tr) { tr.stop(); });
    stream = null;
  }
  function closeCamera() {
    stopStream();
    if (camModal) camModal.hidden = true;
    document.body.style.overflow = '';
  }
  function startStream() {
    return navigator.mediaDevices.getUserMedia({
      video: { facingMode: facing, width: { ideal: 2560 }, height: { ideal: 1440 } },
      audio: false
    }).then(function(s) {
      stopStream();
      stream = s;
      camVideo.srcObject = s;
      camModal.classList.toggle('is-front', facing === 'user');
      var p = camVideo.play();
      if (p && p.catch) p.catch(function() {});
    });
  }
  function openCamera() {
    if (!camModal || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      nativeCamera(); return;
    }
    camModal.hidden = false;
    document.body.style.overflow = 'hidden';
    startStream().catch(function() { closeCamera(); nativeCamera(); });
  }

  if (camModal) {
    document.getElementById('wlCamShot').addEventListener('click', function() {
      var w = camVideo.videoWidth, h = camVideo.videoHeight;
      if (!w || !h) return;
      var scale = Math.min(1, 2400 / Math.max(w, h));
      camCanvas.width  = Math.round(w * scale);
      camCanvas.height = Math.round(h * scale);
      var c = camCanvas.getContext('2d');
      if (facing === 'user') { c.translate(camCanvas.width, 0); c.scale(-1, 1); }
      c.drawImage(camVideo, 0, 0, camCanvas.width, camCanvas.height);
      applyImage(camCanvas.toDataURL('image/jpeg', 0.9), 'Camera photo');
      closeCamera();
    });
    document.getElementById('wlCamFlip').addEventListener('click', function() {
      facing = facing === 'environment' ? 'user' : 'environment';
      startStream().catch(function() { closeCamera(); nativeCamera(); });
    });
    document.getElementById('wlCamCancel').addEventListener('click', closeCamera);
    camModal.addEventListener('click', function(e) { if (e.target === camModal) closeCamera(); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !camModal.hidden) closeCamera();
    });
  }
}

function attachEmailCaptureListeners() {
  var btn    = document.getElementById('wec-btn');
  var input  = document.getElementById('wec-input');
  var form   = document.getElementById('wec-form-area');
  var banner = document.getElementById('wec-offer-banner');
  var reveal = document.getElementById('wec-coupon-reveal');
  if (!btn || !input) return;

  function submit() {
    var email = input.value.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      input.classList.add('error');
      input.focus();
      return;
    }
    input.classList.remove('error');
    btn.disabled    = true;
    btn.textContent = '✓';

    if (form)   form.style.display   = 'none';
    if (banner) banner.style.display = 'none';
    if (reveal) reveal.style.display = 'flex';
    attachCouponCopyListener();

    fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        access_key: '7b069b20-bdbf-4c5e-ab61-159536ec9c37',
        subject:    '🎨 New Wearlie Lead — 10% OFF Signup',
        email:      email,
        message:    'Email: ' + email + '\nSource: AI Designer — 10% OFF offer'
      })
    }).catch(function(err) {
      console.warn('[Wearlie] Web3Forms send failed:', err);
    });
  }

  btn.addEventListener('click', submit);
  input.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
}

function attachCouponCopyListener() {
  var copyBtn = document.getElementById('wec-copy-btn');
  if (!copyBtn) return;
  copyBtn.addEventListener('click', function() {
    if (navigator.clipboard) {
      navigator.clipboard.writeText('OFF10').then(function() {
        copyBtn.textContent = '✓ Copied';
        setTimeout(function() { copyBtn.textContent = 'Copy'; }, 2000);
      });
    } else {
      var tmp = document.createElement('input');
      tmp.value = 'OFF10';
      document.body.appendChild(tmp);
      tmp.select();
      document.execCommand('copy');
      document.body.removeChild(tmp);
      copyBtn.textContent = '✓ Copied';
      setTimeout(function() { copyBtn.textContent = 'Copy'; }, 2000);
    }
  });
}

function buildProgressHTML() {
  return `<div class="gen-wrapper" id="genWrapper">
    <div class="gen-bar-track">
      <div class="gen-bar-fill" id="genFill"></div>
    </div>
    <div class="gen-status-row">
      <div class="gen-spinner"></div>
      <span class="gen-pct" id="genPct">0%</span>
      <span class="gen-label">Crafting your design&hellip;</span>
    </div>
    <div class="gen-email-strip" id="genEmailStrip">
      <div class="gen-offer-banner" id="wec-offer-banner">
        <span class="gen-offer-tag">Welcome offer</span>
        <span class="gen-offer-text">Subscribe to get <strong>10% off</strong> on this order</span>
      </div>
      <div class="gen-email-row" id="wec-form-area">
        <input type="email" id="wec-input" placeholder="your@email.com" autocomplete="email" />
        <button type="button" class="gen-email-btn" id="wec-btn">10% Off</button>
      </div>
      <div class="gen-coupon-reveal" id="wec-coupon-reveal">
        <p class="gen-coupon-headline">🎉 Get your 10% off on your order now</p>
        <div class="gen-coupon-box">
          <span class="gen-coupon-code">OFF10</span>
          <button type="button" class="gen-coupon-copy-btn" id="wec-copy-btn">Copy</button>
        </div>
        <p class="gen-coupon-hint">Apply at checkout · one use per order</p>
      </div>
    </div>
  </div>`;
}

function initializeOptionsModal() {
  var modal    = document.getElementById('optionsModal');
  var closeBtn = document.getElementById('closeOptionsModal');
  var confirm  = document.getElementById('confirmOptionsBtn');
  closeBtn.addEventListener('click', closeOptionsModal);
  modal.addEventListener('click', function(e) { if (e.target===modal) closeOptionsModal(); });
  document.addEventListener('keydown', function(e) { if (e.key==='Escape'&&modal.classList.contains('active')) closeOptionsModal(); });
  confirm.addEventListener('click', proceedWithGeneration);
}

function initializeDesignResultModal() {
  var modal    = document.getElementById('designResultModal');
  var closeBtn = document.getElementById('closeDesignResultModal');
  var regen    = document.getElementById('regenerateBtn');
  closeBtn.addEventListener('click', closeWithFlyAnimation);
  modal.addEventListener('click', function(e) { if (e.target===modal) closeWithFlyAnimation(); });
  document.addEventListener('keydown', function(e) { if (e.key==='Escape'&&modal.classList.contains('active')) closeWithFlyAnimation(); });
  regen.addEventListener('click', function() { closeDesignResultModal(); resetPreviewBox(); });
}

function initializeHowItWorks() {
  var btn   = document.getElementById('howItWorksBtn');
  var modal = document.getElementById('howItWorksModal');
  var close = modal.querySelector('.close-modal');
  function closeHIW() {
    var v = modal.querySelector('video');
    if (v) { v.pause(); v.currentTime = 0; }
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }
  if (btn) btn.addEventListener('click', function() { modal.classList.add('active'); document.body.style.overflow='hidden'; });
  close.addEventListener('click', closeHIW);
  modal.addEventListener('click', function(e) { if (e.target===modal) closeHIW(); });
  document.addEventListener('keydown', function(e) { if (e.key==='Escape'&&modal.classList.contains('active')) closeHIW(); });
}

function openOptionsModal() {
  var modal      = document.getElementById('optionsModal');
  var typeSelect = document.getElementById('modalTypeSelect');
  var sizeSelect = document.getElementById('modalSizeSelect');
  var sizeNote   = document.getElementById('sizeNote');
  typeSelect.innerHTML = '';
  if (selectedCategory && productTypes[selectedCategory]) {
    productTypes[selectedCategory].forEach(function(t,i) {
      var o = document.createElement('option');
      o.value = t.value; o.textContent = t.displayName;
      if (i===0) o.selected = true;
      typeSelect.appendChild(o);
    });
  }
  if (selectedCategory==='cap') { sizeSelect.disabled=true; sizeSelect.value='M'; sizeNote.classList.add('visible'); }
  else { sizeSelect.disabled=false; sizeNote.classList.remove('visible'); }
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeOptionsModal() { document.getElementById('optionsModal').classList.remove('active'); document.body.style.overflow=''; }
function closeDesignResultModal() { document.getElementById('designResultModal').classList.remove('active'); document.body.style.overflow=''; }

function closeWithFlyAnimation() {
  var resultImg  = document.getElementById('resultModalImage');
  var preview    = document.getElementById('previewBox');
  if (!resultImg||!resultImg.src||resultImg.src===window.location.href) { closeDesignResultModal(); return; }

  var iR  = resultImg.getBoundingClientRect();
  var pR  = preview.getBoundingClientRect();
  var fly = document.getElementById('flyingImageContainer');
  var fi  = document.getElementById('flyingImage');
  fi.src  = resultImg.src;

  fly.style.cssText = 'display:block;position:fixed;z-index:99999;pointer-events:none;'
    +'top:'+iR.top+'px;left:'+iR.left+'px;width:'+iR.width+'px;height:'+iR.height+'px;'
    +'opacity:1;border-radius:14px;transition:none;';

  closeDesignResultModal();

  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      fly.style.transition = 'top .72s cubic-bezier(.4,0,.2,1),left .72s cubic-bezier(.4,0,.2,1),width .72s cubic-bezier(.4,0,.2,1),height .72s cubic-bezier(.4,0,.2,1),opacity .72s ease,border-radius .72s ease';
      fly.style.top=pR.top+'px'; fly.style.left=pR.left+'px';
      fly.style.width=pR.width+'px'; fly.style.height=pR.height+'px';
      fly.style.borderRadius='24px'; fly.style.opacity='0.85';
    });
  });

  setTimeout(function() {
    fly.style.display='none';
    populatePreviewWithDesign();
    var p=document.getElementById('previewBox');
    p.classList.add('landing');
    setTimeout(function(){p.classList.remove('landing');},700);
  },800);
}

function openDesignResultModal(imageUrl, requestData) {
  var modal         = document.getElementById('designResultModal');
  var resultImg     = document.getElementById('resultModalImage');
  var resultPrice   = document.getElementById('resultModalPrice');
  var resultSummary = document.getElementById('resultOptionsSummary');
  var colorSelect   = document.getElementById('modalColorSelect');
  resultImg.src           = imageUrl;
  resultPrice.textContent = '$'+(variantPrices[requestData.category]||0).toFixed(2);
  var colorName           = colorSelect.options[colorSelect.selectedIndex].text.split(' ').slice(1).join(' ');
  resultSummary.innerHTML = '<strong>Type:</strong> '+requestData.typeDisplayName+'<br><strong>Color:</strong> '+colorName+'<br><strong>Size:</strong> '+requestData.size;
  modal.classList.add('active');
  document.body.style.overflow='hidden';
  launchConfetti();
}

function populatePreviewWithDesign() {
  var preview     = document.getElementById('previewBox');
  var colorSelect = document.getElementById('modalColorSelect');
  var sizeSelect  = document.getElementById('modalSizeSelect');
  var typeSelect  = document.getElementById('modalTypeSelect');
  if (!generatedImageUrl) return;
  var price     = variantPrices[selectedCategory]||0;
  var colorName = colorSelect ? colorSelect.options[colorSelect.selectedIndex].text.split(' ').slice(1).join(' ') : '—';
  var sizeValue = sizeSelect  ? sizeSelect.value : '—';
  var typeName  = typeSelect  ? typeSelect.options[typeSelect.selectedIndex].text : selectedCategory;
  preview.innerHTML = `<div class="preview-inline-result">
    <img src="${generatedImageUrl}" alt="Your AI Design" class="preview-inline-img" oncontextmenu="return false" draggable="false"/>
    <div class="preview-inline-price">$${price.toFixed(2)}</div>
    <div class="preview-inline-meta"><strong>Type:</strong> ${typeName} &nbsp;|&nbsp; <strong>Color:</strong> ${colorName} &nbsp;|&nbsp; <strong>Size:</strong> ${sizeValue}</div>
    <div class="preview-inline-actions">
      <button class="preview-cart-btn" onclick="handleAddToCartFromPreview()">🛒 Add to Cart</button>
      <button class="preview-edit-btn" onclick="wlEditFromPreview()">✏️ Edit Design</button>
      <button class="preview-new-design-btn" onclick="resetPreviewBox()">🔄 New Design</button>
    </div></div>`;
}

window.handleAddToCartFromPreview = async function() { await handleAddToCart(); };

function initializeEditFeature() {
  var applyBtn = document.getElementById('editApplyBtn');
  var input    = document.getElementById('editPromptInput');
  if (!applyBtn || !input) return;

  applyBtn.addEventListener('click', runEditDesign);
  input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') { e.preventDefault(); runEditDesign(); }
  });

  document.querySelectorAll('.edit-chip').forEach(function(chip) {
    chip.addEventListener('click', function() {
      if (isEditing) return;
      input.value = chip.dataset.edit;
      input.focus();
    });
  });
}

function resetEditBox() {
  editCount = 0;
  var input = document.getElementById('editPromptInput');
  if (input) input.value = '';
  var hint = document.getElementById('editHint');
  if (hint) hint.textContent = 'Takes ~30 seconds · updates the design above';
}

function setEditBusy(busy) {
  var applyBtn = document.getElementById('editApplyBtn');
  var input    = document.getElementById('editPromptInput');
  var progress = document.getElementById('editProgress');
  var hint     = document.getElementById('editHint');
  var cartBtn  = document.getElementById('modalAddToCartBtn');
  var regenBtn = document.getElementById('regenerateBtn');

  isEditing = busy;
  if (applyBtn) applyBtn.disabled = busy;
  if (input)    input.disabled    = busy;
  if (cartBtn)  cartBtn.disabled  = busy;
  if (regenBtn) regenBtn.disabled = busy;
  document.querySelectorAll('.edit-chip').forEach(function(c) { c.disabled = busy; });
  if (progress) progress.classList.toggle('on', busy);
  if (hint)     hint.style.display = busy ? 'none' : '';
}

async function runEditDesign() {
  if (isEditing) return;

  var input   = document.getElementById('editPromptInput');
  var barFill = document.getElementById('editBarFill');
  var hint    = document.getElementById('editHint');

  var instruction = (input.value || '').trim();
  if (!instruction) { showMessage("Tell us what to change first.",'error'); input.focus(); return; }
  if (!generatedImageUrl) { showMessage("Generate a design first.",'error'); return; }

  var filename = String(generatedImageUrl).split('?')[0].split('/').pop();
  if (!filename) { showMessage("Generate a design first.",'error'); return; }

  setEditBusy(true);
  if (barFill) barFill.style.width = '0%';

  var width = 0;
  var timer = setInterval(function() {
    if (width >= 96) return;
    width += (width < 60) ? 0.75 : (width < 85 ? 0.3 : 0.06);
    if (barFill) barFill.style.width = width + '%';
  }, 150);

  try {
    var res = await fetch(API_EDIT_URL, {
      method:  'POST',
      headers: { 'Content-Type':'application/json','Accept':'application/json' },
      body: JSON.stringify({
        filename:   filename,
        editPrompt: instruction,
        color:      (lastRequestData && lastRequestData.color) || '',
        type:       (lastRequestData && lastRequestData.type)  || ''
      })
    });

    var rawText = await res.text();
    var data = null;
    try { data = JSON.parse(rawText); } catch(e) {}

    var errObj = (data && data.error) ? data.error : data;

    if (!res.ok || (data && data.success === false)) {
      if (errObj && errObj.message) {
        throw errObj; 
      } else {
        throw { message: "Looks like our servers hit a tiny bump! Let's try generating that again." };
      }
    }

    var newUrl = data && data.data;
    if (newUrl && newUrl.startsWith('http://api.wearlie.com/')) {
      newUrl = newUrl.replace('http://','https://');
    }
    if (!newUrl) throw new Error('No image returned');

    clearInterval(timer);
    if (barFill) barFill.style.width = '100%';

    await new Promise(function(resolve) {
      var img = new Image();
      img.onload  = resolve;
      img.onerror = resolve;
      img.src = newUrl;
    });

    generatedImageUrl = newUrl;
    editCount++;

    var modalImg = document.getElementById('resultModalImage');
    if (modalImg) {
      modalImg.src = newUrl;
      modalImg.style.animation = 'none';
      void modalImg.offsetWidth;
      modalImg.style.animation = '';
    }

    input.value = '';
    showMessage("✨ Design updated!",'success');

    if (editCount >= 4 && hint) {
      hint.textContent = 'Tip: after several tweaks the print can soften — generate fresh for the sharpest result.';
    }
  } catch(err) {
    clearInterval(timer);
    console.error('[Wearlie] Edit error:', err);
    
    // Extract friendly message
    var msg = err.message || "Something went wrong on our end. Give it another shot!";
    if (msg.includes('<html>') || msg.includes('nginx')) {
      msg = "Our server is doing a quick reboot. Let's try again in a few seconds!";
    }
    
    // Show just the clean message
    showMessage(msg, 'error');

  } finally {
    clearInterval(timer);
    setEditBusy(false);
    if (barFill) barFill.style.width = '0%';
  }
}

window.wlEditFromPreview = function() {
  if (!generatedImageUrl || !lastRequestData) {
    showMessage("Generate a design first.",'error');
    return;
  }
  openDesignResultModal(generatedImageUrl, lastRequestData);
  setTimeout(function() {
    var i = document.getElementById('editPromptInput');
    if (i) i.focus();
  }, 450);
};

function handleGenerateClick() {
  if (isGenerating) return;
  if (!selectedCategory) { showMessage("Please select a product category first.",'error'); return; }
  var promptInput = document.getElementById('promptInput');
  if (!promptInput||!promptInput.value.trim()) { showMessage("Please enter a design prompt.",'error'); return; }
  pendingPrompt = promptInput.value.trim();
  openOptionsModal();
}

async function proceedWithGeneration() {
  var typeSelect   = document.getElementById('modalTypeSelect');
  var colorSelect  = document.getElementById('modalColorSelect');
  var sizeSelect   = document.getElementById('modalSizeSelect');
  var selectedType = typeSelect.value;
  if (!selectedType)  { showMessage("Please select a product type",'error'); return; }
  if (!pendingPrompt) { showMessage("Error: Missing design description",'error'); return; }
  closeOptionsModal();
  await callGenerationAPI({
    prompt:pendingPrompt, category:selectedCategory,
    type:selectedType, typeDisplayName:typeSelect.options[typeSelect.selectedIndex].text,
    color:colorSelect.value, size:sizeSelect.value, style:'realistic'
  });
  pendingPrompt = null;
}

function withReferenceImage(payload) {
  if (referenceImage) payload.reference_image = referenceImage;
  return payload;
}

function showQualityPrompt(info){
  var box = document.getElementById('previewBox');
  if (!box) return;
  var r = info.requirements || {}, p = info.provided || {};
  var head = (info.code === 'IMAGE_HAS_PERSON' || info.code === 'IMAGE_BLOCKED')
    ? "We can't use that photo"
    : 'That photo is too low quality to print';
  var specs = '';
  if (r.minWidth){
    specs =
      '<dl class="cw-quality__specs">' +
        '<dt>You sent</dt><dd>' + p.width + ' &times; ' + p.height + ' px (' + p.megapixels + ' MP)</dd>' +
        '<dt>Minimum</dt><dd>' + r.minWidth + ' &times; ' + r.minHeight + ' px (' + r.minMegapixels + ' MP)</dd>' +
        '<dt>Best</dt><dd>' + r.recommendedWidth + ' &times; ' + r.recommendedHeight + ' px (' + r.recommendedMegapixels + ' MP)</dd>' +
        '<dt>Camera</dt><dd>' + r.cameraSetting + '</dd>' +
      '</dl>';
  }
  box.innerHTML =
    '<div class="cw-quality">' +
      '<div class="cw-quality__head"><span>&#9888;</span><span>' + head + '</span></div>' +
      '<p class="cw-quality__msg">' + (info.message || 'Please attach a larger photo and try again.') + '</p>' +
      specs +
      '<div class="cw-quality__actions">' +
        '<button type="button" class="cw-quality__btn" id="cwQualityRetry">Choose another photo</button>' +
        '<button type="button" class="cw-quality__btn cw-quality__btn--ghost" id="cwQualityDrop">Design without a photo</button>' +
      '</div>' +
    '</div>';

  var retry = document.getElementById('cwQualityRetry');
  if (retry) retry.addEventListener('click', function(){
    var picker = document.getElementById('cwRefImage') || document.getElementById('wlRefImage');
    if (picker) picker.click();
  });
  var drop = document.getElementById('cwQualityDrop');
  if (drop) drop.addEventListener('click', function(){
    var clr = document.getElementById('cwRefClear') || document.getElementById('wlRefClear');
    if (clr) clr.click();
    if (typeof resetPreviewBox === 'function') resetPreviewBox();
  });
}

async function callGenerationAPI(requestData) {
  lastRequestData = requestData;

  var preview     = document.getElementById('previewBox');
  var generateBtn = document.getElementById('generateBtn');
  var btnContent  = generateBtn.querySelector('.btn-content');
  var btnLoading  = generateBtn.querySelector('.btn-loading');

  isGenerating             = true;
  generateBtn.disabled     = true;
  btnContent.style.display = 'none';
  btnLoading.style.display = 'flex';

  preview.innerHTML = buildProgressHTML();

  var fill  = document.getElementById('genFill');
  var pct   = document.getElementById('genPct');
  var width = 0;

  var progressInterval = setInterval(function() {
    if (width >= 97) return; 

    var step;
    if      (width < 60) step = 0.9;
    else if (width < 80) step = 0.9;
    else if (width < 90) step = 0.35;
    else                 step = 0.08;

    width = Math.min(97, width + step);
    if (fill) fill.style.width = width + '%';
    if (pct)  pct.textContent  = Math.floor(width) + '%';
  }, 150);

  wecTimer = setTimeout(function() {
    var strip = document.getElementById('genEmailStrip');
    if (strip) {
      strip.classList.add('visible');
      attachEmailCaptureListeners();
      attachCouponCopyListener();
    }
  }, 2000);

  try {
    var res = await fetch(API_URL, {
      method:  'POST',
      headers: { 'Content-Type':'application/json','Accept':'application/json' },
      body: JSON.stringify(withReferenceImage({
        color:requestData.color, type:requestData.type, size:requestData.size,
        style:requestData.style, prompt:requestData.prompt,
        description:'3D rotational-style', category:requestData.category
      }))
    });

    var rawText = await res.text();
    var data = null;
    try { data = JSON.parse(rawText); } catch(e) {}

    if (res.status === 422 && data && data.requirements){
      clearInterval(progressInterval);
      clearTimeout(wecTimer);
      showQualityPrompt(data);
      return;
    }

    var errObj = (data && data.error) ? data.error : data;

    if (!res.ok || (data && data.success === false)) {
      if (errObj && errObj.message) {
        throw errObj; 
      } else {
        throw { message: "Looks like our servers hit a tiny bump! Let's try generating that again." };
      }
    }

    generatedImageUrl = data.data;

    if (generatedImageUrl) {
      if (generatedImageUrl.startsWith('http://api.wearlie.com/'))
        generatedImageUrl = generatedImageUrl.replace('http://','https://');

      clearInterval(progressInterval);
      if (fill) fill.style.width = '100%';
      if (pct)  pct.textContent  = '100%';

      var img = new Image();
      img.onload = function() {
        resetPreviewBox();
        resetEditBox();
        openDesignResultModal(generatedImageUrl, requestData);
        showMessage("🎉 Design generated successfully!",'success');
      };
      img.src = generatedImageUrl;
    }
  } catch(err) {
    clearInterval(progressInterval);
    console.error('Generation Error:', err);
    
    // Extract exact message without any error codes or jargon
    var msg = err.message || "Something went wrong on our end. Give it another shot!";
    
    // Fallback if Nginx dumps raw HTML instead of JSON
    if (msg.includes('<html>') || msg.includes('nginx')) {
      msg = "Our server is doing a quick reboot. Let's try again in a few seconds!";
    }

    // Scroll back to the prompt input and focus it smoothly
    var retryScript = "var p = document.getElementById('promptInput'); p.scrollIntoView({behavior: 'smooth', block: 'center'}); setTimeout(function(){ p.focus(); }, 400);";
    
    // Render the beautiful animated UI (without action/rules text)
    preview.innerHTML = 
      '<div class="friendly-error-container">' +
        '<div class="friendly-error-icon">🎨💨</div>' +
        '<h3 class="friendly-error-title">Oops! Design Interrupted</h3>' +
        '<p class="friendly-error-msg">' + msg + '</p>' +
        '<button class="friendly-error-btn" onclick="' + retryScript + '">Try a New Idea</button>' +
      '</div>';
      
  } finally {
    clearTimeout(wecTimer);
    isGenerating             = false;
    generateBtn.disabled     = false;
    btnContent.style.display = 'flex';
    btnLoading.style.display = 'none';
  }
}

function resetPreviewBox() {
  document.getElementById('previewBox').innerHTML = `
    <div class="preview-placeholder">
      <div class="placeholder-icon">
        <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <circle cx="8.5" cy="8.5" r="1.5"></circle>
          <polyline points="21,15 16,10 5,21"></polyline>
        </svg>
      </div>
      <h3>Your Design Will Preview Here</h3>
    </div>`;
}

function initializeCategoryButtons() {
  document.querySelectorAll('.category-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      document.querySelectorAll('.category-btn').forEach(function(b){b.classList.remove('active');b.setAttribute('aria-pressed','false');});
      btn.classList.add('active');
      btn.setAttribute('aria-pressed','true');
      selectedCategory = btn.dataset.category;
      if (typeof wlUpdateReady === 'function') wlUpdateReady();
    });
    btn.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); btn.click(); }
    });
  });
}

function disableImageDownload() {
  document.addEventListener('contextmenu', function(e) {
    if (e.target.tagName==='IMG') { e.preventDefault(); showMessage('Image downloading is disabled','info'); return false; }
  });
  document.addEventListener('dragstart', function(e) {
    if (e.target.tagName==='IMG') { e.preventDefault(); return false; }
  });
}

function showMessage(message, type) {
  type = type||'info';
  var box = document.getElementById('statusMessage');
  if (!box) {
    box = document.createElement('div');
    box.id = 'statusMessage';
    box.style.cssText = 'position:fixed;top:20px;right:20px;padding:16px 24px;border-radius:12px;color:white;font-weight:700;z-index:9999;box-shadow:0 10px 25px rgba(0,0,0,0.2);opacity:0;transition:opacity 0.3s,transform 0.3s;transform:translateY(-20px);max-width:400px;text-align:center;';
    document.body.appendChild(box);
  }
  var colors={success:'#48bb78',error:'#f56565',info:'#4299e1'};
  box.style.backgroundColor=colors[type]||colors.info;
  box.textContent=message; box.style.opacity='1'; box.style.transform='translateY(0)';
  clearTimeout(box.timer);
  box.timer=setTimeout(function(){box.style.opacity='0';box.style.transform='translateY(-20px)';},4000);
}

async function handleAddToCart() {
  if (!generatedImageUrl||!selectedCategory) { showMessage("Please generate your design first!",'error'); return; }
  var variantId = variantMap[selectedCategory];
  if (!variantId) { showMessage("Error: Invalid product configuration",'error'); return; }

  var colorSelect     = document.getElementById('modalColorSelect');
  var colorName       = colorSelect.options[colorSelect.selectedIndex].text.split(' ').slice(1).join(' ');
  var sizeSelect      = document.getElementById('modalSizeSelect');
  var sizeValue       = sizeSelect.value;
  var typeSelect      = document.getElementById('modalTypeSelect');
  var typeDisplayName = typeSelect ? typeSelect.options[typeSelect.selectedIndex].text : selectedCategory;
  var addToCartBtn    = document.getElementById('modalAddToCartBtn');
  var originalHTML    = addToCartBtn ? addToCartBtn.innerHTML : '';

  if (addToCartBtn) {
    addToCartBtn.disabled=true;
    addToCartBtn.innerHTML='<span class="btn-content" style="display:flex;align-items:center;gap:8px;justify-content:center;"><span class="loading-spinner dark-spinner" style="width:18px;height:18px;border-width:2px;"></span><span>Adding...</span></span>';
  }

  try {
    var res = await fetch("/cart/add.js",{
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({ id:variantId.toString(), quantity:1, properties:{ "AI Generated Design":generatedImageUrl, "Color":colorName, "Size":sizeValue, "Type":typeDisplayName } })
    });
    if (!res.ok) { var e=await res.json(); throw new Error(e.description||"Failed"); }
    await res.json();
    showMessage("✅ Added to cart successfully!",'success');
    setTimeout(function(){window.location.href="/cart";},1000);
  } catch(error) {
    console.error("Add to cart error:",error);
    try {
      var form=document.createElement('form'); form.method='post'; form.action='/cart/add'; form.style.display='none';
      function af(n,v){var i=document.createElement('input');i.name=n;i.value=v;form.appendChild(i);}
      af('id',variantId); af('quantity','1');
      var props={"AI Generated Design":generatedImageUrl,"Color":colorName,"Size":sizeValue,"Type":typeDisplayName};
      for(var k in props) af('properties['+k+']',props[k]);
      document.body.appendChild(form); form.submit();
    } catch(fb) {
      showMessage("Failed to add to cart. Please try again.",'error');
      if (addToCartBtn){addToCartBtn.disabled=false;addToCartBtn.innerHTML=originalHTML;}
    }
  }
}

function launchConfetti() {
  var canvas=document.getElementById('confettiCanvas'); if(!canvas) return;
  var ctx=canvas.getContext('2d');
  canvas.width=canvas.offsetWidth; canvas.height=canvas.offsetHeight;
  var colors=['#FFD000','#FF9500','#4facfe','#00f2fe','#ab90fc','#48bb78','#fc8181'];
  var pieces=[];
  for(var i=0;i<90;i++) pieces.push({x:Math.random()*canvas.width,y:Math.random()*canvas.height*-1,w:6+Math.random()*7,h:10+Math.random()*6,color:colors[Math.floor(Math.random()*colors.length)],rot:Math.random()*Math.PI*2,rotSpeed:(Math.random()-0.5)*0.12,speed:1.5+Math.random()*2.5,wobble:Math.random()*Math.PI*2});
  var frame,elapsed=0;
  function draw(){
    ctx.clearRect(0,0,canvas.width,canvas.height); elapsed++; var allDone=true;
    pieces.forEach(function(p){
      if(p.y<canvas.height+20) allDone=false;
      p.y+=p.speed; p.rot+=p.rotSpeed; p.wobble+=0.05; p.x+=Math.sin(p.wobble)*0.8;
      ctx.save(); ctx.translate(p.x,p.y); ctx.rotate(p.rot); ctx.fillStyle=p.color;
      ctx.globalAlpha=Math.max(0,1-elapsed/220); ctx.fillRect(-p.w/2,-p.h/2,p.w,p.h); ctx.restore();
    });
    if(!allDone&&elapsed<240){frame=requestAnimationFrame(draw);}
    else{ctx.clearRect(0,0,canvas.width,canvas.height);cancelAnimationFrame(frame);}
  }
  draw();
}


/* ===== v11: example chips + generate-ready state ===== */
function wlUpdateReady(){
  var g=document.getElementById('generateBtn'), p=document.getElementById('promptInput');
  if(!g||!p) return;
  var ready = !!selectedCategory && p.value.trim().length>3;
  g.classList.toggle('is-ready', ready);
}
document.addEventListener('DOMContentLoaded', function(){
  var p=document.getElementById('promptInput');
  if(p){ p.addEventListener('input', wlUpdateReady); }
  document.addEventListener('click', function(e){
    var eg=e.target.closest && e.target.closest('.wl-eg');
    if(eg && p){
      p.value = eg.getAttribute('data-eg')||'';
      p.dispatchEvent(new Event('input',{bubbles:true}));
      p.focus();
      if(!selectedCategory){
        var first=document.querySelector('.category-btn'); if(first) first.click();
      }
      wlUpdateReady();
    }
  });
  setTimeout(wlUpdateReady,300);
});
